import Mail from '@/assets/mail.svg'
import {type IconProps} from './types'

export const MailIcon = ({className}: IconProps) => <Mail className={className} />
